export default __webpack_public_path__ + "static/media/330_business02-es-mobile.2346df30.png";